module.exports = __webpack_public_path__ + "static/media/icon_consumidor_final.ec17b3eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_consumidor_final.svg
// module id = 326
// module chunks = 0